import { useQuery } from 'react-query';
import client from 'client';
import { default as ApiConfig } from 'config';
import Cookie from 'js-cookie';

let groupId = null;

const useGroupId = (uniqueName: string) => {
    return useQuery<number, Error>(['eventGroupId'], () => fetchEventGroupId(uniqueName));
};

export const fetchEventGroupId = async (uniqueName: string): Promise<number> => {
    const { data } = await client().get<number>('/api/v1/event/groupIdByUniqueName', {
        params: {
            uniqueName,
        },
    });

    groupId = data;
    return data;
};

export const isPreviewMode = (eventGroupId: number): boolean => {
    const previewCookieName = `${ApiConfig.previewCookieName}-${eventGroupId}`;
    return !!Cookie.get(previewCookieName);
};

export default useGroupId;

export const getGroupId = () => {
    return groupId;
};
